import React, { useContext, useEffect, useState } from "react";

import useUrlParams from "../../../../../../customHooks/useUrlParams";
import { AppContext } from "../../../../../../context/context";
import CompaniesAutocomplete from "../../../../customer/companies/CompaniesAutocomplete";
import { payloadTypes } from "../../../../../../context/reducer";
import useLabels from "../../../../../../customHooks/useLabels";
import SubsidiarySelect from "../../../../../../customComponents/SubsidiarySelect";
import {
  EMPTY_STRING,
  emptyFunc,
  FETCH_MORE_DATA,
  ROWS_PER_PAGE,
  TicketStatus,
} from "../../../../../../utils/constants";
import SiteSelect from "../../../../../../customComponents/SiteSelect";
import Input from "../../../../../../stories/Input/Input";
import { Button } from "../../../../../../stories/Button/Button";
import {
  JunctionStatus,
  PriorityEnum,
} from "../../../../../../utils/Enum.types";

import RightArrow from "../../../../../../images/ArrowRight.svg";
import {
  CustomModal,
  getModifiedScrollHeight,
  handleMUISelectEvent,
  junctionStatusIcons,
} from "../../../../../../utils/UtilFunctions";
import { AddModalStyles } from "../../../../../../styles/CustomModalStyles";
import Legends from "../../../maps/ticketing/junctionDetails/Legends";
import JunctionWiseAsset from "./JunctionWiseAsset";
import { useLazyQuery } from "@apollo/client";
import { GetJunctionsForDashboard } from "../../../masters/subsidary/junctions/queries/queries";
import {
  GetJunctionsData,
  GetJunctionsVars,
  JunctionEdge,
  JunctionQueryType,
} from "../../../masters/subsidary/junctions/queries/types";

import { OrderDirection } from "../../../../../../utils/commonQueryTypes";
import { AtsSubsidiaryOrderField } from "../../../masters/subsidary/queries/types";
import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";
import SuppliersAutocomplete from "../../../purchase/purchaseorder/rfqtopo/components/SuppliersAutocomplete";
import { TableType } from "../../../../customer/companies/queries/types";
import { LdgrQueryType } from "../../../masters/supplier/queries/types";
import {
  LabeledAutocomplete,
  labelClasses,
} from "../../../../../../styles/AutocompleteStyles";
import NotWorking from "../../../../../../images/dashboard/Not Working.svg";
import { TextField } from "@mui/material";
import ViewTicket from "../../../../../../images/View Ticket.svg";
import Maps from "../../../../../../images/my_location.svg";
import { useNavigate } from "react-router-dom";
import RaisedTicketDetails from "../../../maps/ticketing/junctionDetails/raisedTickets/RaisedTicketDetails";
import { AssetDetailsPageFor } from "../../../maps/ticketing/junctionDetails/raisedTickets/AssetDetails";
import { GetTicketsResult } from "../../../maps/queries/types";
import {
  AtsTicketsOrderField,
  GetTicketsVars,
  TicketsQueryType,
} from "../../../../../../queries/types";
import { GetTickets } from "../../../../../../queries/queries";
import { mapsPayloadType } from "../../../maps/context/reducer";
import { MapsContext } from "../../../maps/context/context";
import AssetTypeMapView from "../../AssetTypeMapView";
import { APIProvider } from "@vis.gl/react-google-maps";
import LoadingModal from "../../../../../pages/LoadingModal";
import validatedLocation from "../../../../../../images/my_location.svg";
import notValidatedLocation from "../../../../../../images/not_validated_location.svg";
import { Keys } from "../../../../../../utils/Enum.keys";

export enum JunctionPageType {
  TICKET_STATUS = "TICKET_STATUS",
  JUNCTION_STATUS = "JUNCTION_STATUS",
  NOT_WORKING_LIST = "NOT_WORKING",
}
interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
  junctionPageType: JunctionPageType;
  selectedJunctionStatus?: JunctionStatus;
}

const CompleteSignalDetails = ({
  setModalFlag,
  junctionPageType,
  selectedJunctionStatus,
}: Props) => {
  const { company_id, sub_id, siteID, customer_id } = useUrlParams();
  const { state, dispatch } = useContext(AppContext);
  const { dispatch: mapsDispatch, state: mapsState } = useContext(MapsContext);

  const [ticketDetails, setTicketDetails] = useState(false);
  const { ledgerLabel } = useLabels();
  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [items, setItems] = useState<JunctionEdge[]>([]);
  const [searchJunction, setSearchJunction] = useState("");
  const [status, setStatus] = useState("");
  const navigate = useNavigate();
  const [junctionDetails, setJunctionDetails] = useState(false);
  const junctionQueryTypeOption = Object.values(JunctionQueryType);
  const [selectedQueryType, setsSelectedQueryType] =
    useState<JunctionQueryType | null>(null);

  const [mapView, setMapView] = useState(false);

  const { user_details } = useLoggedInUserDetails();

  const [GetJuncs, { data: junctionData, loading, fetchMore }] = useLazyQuery<
    GetJunctionsData,
    GetJunctionsVars
  >(GetJunctionsForDashboard);

  const { companyLabel, subsidiaryLabel, subsidiarySiteLabel, junctionLabel } =
    useLabels();

  useEffect(() => {
    if (customer_id) {
      GetJuncs({
        variables: {
          after: null,
          customerID: customer_id,
          companyID: company_id ? company_id : state.companyId,
          subsidiaryID: sub_id ? sub_id : state.subsidiaryId,
          siteID: siteID ? siteID : state.subSiteId,
          empID: user_details.id,
          first: ROWS_PER_PAGE,
          orderBy: {
            direction: OrderDirection.ASC,
            field: AtsSubsidiaryOrderField.NAME,
          },
          priority: [],
          jType: state.junctionType ? [state.junctionType] : [],
          name: searchJunction,
          ldgrID: state.supplierId,
          junctionStatus:
            junctionPageType === JunctionPageType.JUNCTION_STATUS &&
            selectedJunctionStatus
              ? [selectedJunctionStatus]
              : [],
          ticketStatus:
            junctionPageType === JunctionPageType.NOT_WORKING_LIST
              ? [
                  TicketStatus.OPEN,
                  TicketStatus.ASSIGNED,
                  TicketStatus.RE_OPENED,
                ]
              : status === "WORKING"
                ? [TicketStatus.RESOLVED, TicketStatus.CLOSED]
                : status === "NOT WORKING"
                  ? [
                      TicketStatus.OPEN,
                      TicketStatus.ASSIGNED,
                      TicketStatus.RE_OPENED,
                    ]
                  : [],
          queryType: selectedQueryType
            ? selectedQueryType
            : JunctionQueryType.ALL,
        },
      });
    }
  }, [
    GetJuncs,
    company_id,
    customer_id,
    state.companyId,
    sub_id,
    state.subsidiaryId,
    siteID,
    state.subSiteId,
    user_details.id,
    searchJunction,
    state.junctionType,
    state.supplierId,
    status,
    selectedJunctionStatus,
    junctionPageType,
    selectedQueryType,
  ]);
  const handleScroll = (e: React.UIEvent<HTMLDivElement, UIEvent>) => {
    const target = e.target as HTMLDivElement;
    const scrollTop = target.scrollTop;
    const scrollHeight = target.scrollHeight;
    const clientHeight = target.clientHeight;

    if (scrollTop + clientHeight >= getModifiedScrollHeight(scrollHeight)) {
      if (hasNextPage && !loading) {
        fetchMore({
          variables: {
            first: FETCH_MORE_DATA,
            after: endCursor,
          },
          updateQuery: (prevResult, { fetchMoreResult }) => {
            if (!fetchMoreResult) return prevResult;

            const newEdges = fetchMoreResult.GetJunctions.edges;
            const pageInfo = fetchMoreResult.GetJunctions.pageInfo;
            setEndCursor(pageInfo.endCursor);
            setHasNextPage(pageInfo.hasNextPage);

            const duplicateCheck = prevResult.GetJunctions.edges.filter(
              ({ node: { id } }) =>
                newEdges.findIndex(
                  ({ node: { id: newId } }) => newId === id,
                ) !== -1,
            );

            if (duplicateCheck.length > 0) return prevResult;

            return {
              // GetJunctions: {
              //   edges: [...items, ...newEdges],
              //   pageInfo,
              //   totalCount: junctionData
              //     ? junctionData.GetJunctions.totalCount!
              //     : 0,
              // },
              GetJunctions: {
                ...prevResult.GetJunctions,
                edges: [...prevResult.GetJunctions.edges, ...newEdges],
                pageInfo,
                totalCount: junctionData
                  ? junctionData.GetJunctions.totalCount!
                  : 0,
              },
            };
          },
        });
      }
    }
  };
  useEffect(() => {
    if (junctionData && !loading) {
      const newData = junctionData.GetJunctions.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = items.find(
            (employee) => employee.node.id === newCompany.node.id,
          );
          if (filteredStudent) {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        });
        setItems(updatedNewData);
      } else {
        setItems(newData);
      }
      setEndCursor(junctionData.GetJunctions.pageInfo.endCursor);
    }
    // eslint-disable-next-line
  }, [junctionData, loading]);

  const handleClear = () => {
    dispatch({
      type: payloadTypes.SET_SUPPLIER_ID,
      payload: {
        supplierId: 0,
      },
    });
    dispatch({
      type: payloadTypes.SET_COMPANY_ID,
      payload: {
        companyId: 0,
      },
    });
    dispatch({
      type: payloadTypes.SET_SUB_ID,
      payload: {
        subsidiaryId: 0,
      },
    });
    dispatch({
      type: payloadTypes.SET_SUB_SITE_ID,
      payload: {
        subSiteId: 0,
      },
    });
    dispatch({
      type: payloadTypes.SET_JUNCTION_ID,
      payload: {
        junctionID: 0,
      },
    });
  };

  useEffect(() => {
    handleClear();
  }, []);
  const [GetTicket, { data: ticketData }] = useLazyQuery<
    GetTicketsResult,
    GetTicketsVars
  >(GetTickets);
  useEffect(() => {
    if (customer_id) {
      GetTicket({
        variables: {
          after: null,
          first: ROWS_PER_PAGE,
          name: EMPTY_STRING,
          orderBy: {
            direction: OrderDirection.ASC,
            field: AtsTicketsOrderField.TICKET_NO,
          },

          companyID: 0,
          customerID: customer_id,
          subsidiaryID: 0,
          junctionID: mapsState.assetTypeId ? mapsState.assetTypeId : 0,
          reason: EMPTY_STRING,
          input: {
            itemID: 0,
            ldgrID: 0,
            stckCategoryID: 0,
            stckGroupID: 0,
            stckManufacturerID: 0,
            stckSubCategoryID: 0,
            stckUomID: 0,
            query_type: TicketsQueryType.ALL,
            itemDetailsID: 0,
            status: [
              TicketStatus.ASSIGNED,
              TicketStatus.OPEN,
              TicketStatus.RE_OPENED,
            ],
            empID: user_details.id!,
            priority: [],
          },
          siteID: 0,
        },
      });
    }
  }, [GetTicket, user_details.id, customer_id, mapsState.assetTypeId]);

  return (
    <>
      {junctionPageType === JunctionPageType.NOT_WORKING_LIST && (
        <div className="d-signal-complete-details__nw">
          <img src={NotWorking} alt="" />
          <b>Tickets Raised</b>
        </div>
      )}
      <div
        className={`d-signal-complete-details${
          junctionPageType === JunctionPageType.NOT_WORKING_LIST ? "--nw" : ""
        }`}
      >
        <div className="d-signal-details__filters row g-0">
          {!company_id ? (
            <div className="col-2">
              <CompaniesAutocomplete
                onChange={(newValue) => {
                  if (newValue) {
                    dispatch({
                      type: payloadTypes.SET_COMPANY_ID,
                      payload: {
                        companyId: newValue.node.id,
                      },
                    });
                  } else {
                    dispatch({
                      type: payloadTypes.SET_COMPANY_ID,
                      payload: {
                        companyId: 0,
                      },
                    });
                  }
                }}
                onKeyDown={emptyFunc}
                label={companyLabel}
                value={state.companyId ? state.companyId : 0}
              />
            </div>
          ) : null}

          {!sub_id ? (
            <div className="col-2">
              <SubsidiarySelect
                onChange={(newValue) => {
                  if (newValue) {
                    dispatch({
                      type: payloadTypes.SET_SUB_ID,
                      payload: {
                        subsidiaryId: newValue.node.id,
                      },
                    });
                  } else {
                    dispatch({
                      type: payloadTypes.SET_SUB_ID,
                      payload: {
                        subsidiaryId: 0,
                      },
                    });
                    dispatch({
                      type: payloadTypes.SET_SUB_SITE_ID,
                      payload: {
                        subSiteId: 0,
                      },
                    });
                    dispatch({
                      type: payloadTypes.SET_JUNCTION_ID,
                      payload: {
                        junctionID: 0,
                      },
                    });
                  }
                }}
                label={subsidiaryLabel}
                companyID={
                  company_id
                    ? company_id
                    : state.companyId
                      ? state.companyId
                      : 0
                }
                onKeyDown={emptyFunc}
                value={state.subsidiaryId ? state.subsidiaryId : 0}
              />
            </div>
          ) : null}
          {!siteID ? (
            <div className="col-2">
              <SiteSelect
                onChange={(newValue) => {
                  if (newValue) {
                    dispatch({
                      type: payloadTypes.SET_SUB_SITE_ID,
                      payload: {
                        subSiteId: newValue.value,
                      },
                    });
                  } else {
                    dispatch({
                      type: payloadTypes.SET_SUB_SITE_ID,
                      payload: {
                        subSiteId: 0,
                      },
                    });
                    dispatch({
                      type: payloadTypes.SET_JUNCTION_ID,
                      payload: {
                        junctionID: 0,
                      },
                    });
                  }
                }}
                companyId={
                  company_id
                    ? company_id
                    : state.companyId
                      ? state.companyId
                      : 0
                }
                subsidiaryId={
                  sub_id ? sub_id : state.subsidiaryId ? state.subsidiaryId : 0
                }
                onKeyDown={emptyFunc}
                value={state.subSiteId ? state.subSiteId : 0}
                label={subsidiarySiteLabel}
              />
            </div>
          ) : null}

          <div className="col-2">
            <SuppliersAutocomplete
              onChange={(newValue) => {
                if (newValue) {
                  dispatch({
                    type: payloadTypes.SET_SUPPLIER_ID,
                    payload: {
                      supplierId: newValue.value as number,
                    },
                  });
                } else {
                  dispatch({
                    type: payloadTypes.SET_SUPPLIER_ID,
                    payload: {
                      supplierId: 0,
                    },
                  });
                }
              }}
              label={ledgerLabel}
              input={{
                itemID: 0,
                query_type: LdgrQueryType.ALL,
                tableLevel: TableType.JUNCTION,
              }}
              value={state.supplierId}
            />
          </div>
          <div className="col">
            <LabeledAutocomplete
              className={labelClasses.inputRoot}
              options={["WORKING", "NOT WORKING"]}
              // onKeyDown={onKeyDown}
              // slotProps={{
              //   listbox: {
              //     onScroll: handleScroll,
              //   },
              // }}
              value={status}
              onChange={(e, newValue) => {
                if (newValue) {
                  setStatus(newValue as string);
                } else {
                  setStatus("");
                }
              }}
              openOnFocus
              forcePopupIcon
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  autoFocus={false}
                  label={"Status"}
                  className={labelClasses.formControlRoot}
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                    },
                  }}
                />
              )}
            />
          </div>
          <div className="col-2">
            <LabeledAutocomplete
              className={labelClasses.inputRoot}
              options={junctionQueryTypeOption}
              value={selectedQueryType}
              onKeyDown={(e) => {
                if (e.key === Keys.ENTER) {
                  e.preventDefault();
                  handleMUISelectEvent(e);
                }
              }}
              onChange={(event, newValue) => {
                if (newValue) {
                  setsSelectedQueryType(newValue as JunctionQueryType);
                } else {
                  setsSelectedQueryType(null);
                }
              }}
              openOnFocus
              forcePopupIcon
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  className={labelClasses.formControlRoot}
                  label="Geo Validated"
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                    },
                  }}
                />
              )}
            />
          </div>
        </div>
        <div className="d-signal-details__total">
          <div>
            {selectedJunctionStatus ? (
              <img src={junctionStatusIcons[selectedJunctionStatus]} />
            ) : null}
            <b>Total</b>
            <span>{junctionLabel}</span>
          </div>
          <div className="overall-total-count">
            <b>{junctionData ? junctionData.GetJunctions.totalCount : 0}</b>
          </div>
        </div>

        <Input
          id="data_search"
          placeholder="Search.."
          onChange={(e) => setSearchJunction(e.target.value)}
        />
        <div className="d-signal-complete-details__ul" onScroll={handleScroll}>
          <ul>
            {junctionData ? (
              items.map(({ node: data }, index) => {
                const img = require(
                  `../../../../../../images/ItemIcons/${
                    data.icon ? data.icon : "junction"
                  }.svg`,
                );

                return (
                  <li key={index}>
                    <div className="d-signal-complete-details--h">
                      <div className="d-signal-complete-details--h--f">
                        <span> {index + 1}. </span>
                        <div
                          className={`d-signal-complete-details--h--flex ${
                            data.priority === PriorityEnum.CRITICAL
                              ? "border-red"
                              : data.priority === PriorityEnum.MEDIUM
                                ? "border-yellow"
                                : data.priority === PriorityEnum.LOW
                                  ? "border-green"
                                  : ""
                          }
  
                `}
                        >
                          <img src={img} alt="" />
                          <div>
                            <b className="d-signal-complete-details--h--item">
                              {data.name}
                            </b>{" "}
                            <span>
                              {data.code},{data.alias ?? ""}
                            </span>
                            <div className="d-signal-complete-details--h--span">
                              <span>
                                {" "}
                                {data.vendorDetails.desc}, Arms: {data.arms}
                              </span>
                            </div>
                          </div>
                          {/* <div>
              <span>{assetDetail.subsidiaryName}</span>
              <span>{assetDetail.siteName}</span>
            </div> */}
                        </div>
                      </div>
                      <div className="d-signal-complete-details__view">
                        <div>
                          <b>{data.remarks}</b>
                        </div>
                        {junctionPageType ===
                        JunctionPageType.NOT_WORKING_LIST ? (
                          <>
                            <img
                              src={Maps}
                              alt=""
                              onClick={() => {
                                if (
                                  junctionPageType ===
                                  JunctionPageType.NOT_WORKING_LIST
                                ) {
                                  mapsDispatch({
                                    type: mapsPayloadType.ASSET_TYPE_ID,
                                    payload: {
                                      assetTypeId: data.id,
                                    },
                                  });
                                  setMapView(!mapView);
                                }
                              }}
                            />
                            <button
                              className="d-signal-complete-details__view--button"
                              onClick={() => {
                                if (
                                  junctionPageType ===
                                  JunctionPageType.NOT_WORKING_LIST
                                ) {
                                  mapsDispatch({
                                    type: mapsPayloadType.ASSET_TYPE_ID,
                                    payload: {
                                      assetTypeId: data.id,
                                    },
                                  });
                                }
                                dispatch({
                                  type: payloadTypes.SET_JUNCTION_ID,
                                  payload: {
                                    junctionID: data.id,
                                  },
                                });

                                mapsDispatch({
                                  type: mapsPayloadType.TICKET,
                                  payload: {
                                    ticketId: ticketData
                                      ? ticketData.GetTickets.edges[0].node.id
                                      : 0,
                                  },
                                });
                                setTicketDetails(!ticketDetails);
                              }}
                            >
                              View Ticket <img src={ViewTicket} alt="" />
                            </button>
                          </>
                        ) : (
                          <></>
                        )}
                        <img
                          src={
                            data.isLocValidated
                              ? validatedLocation
                              : notValidatedLocation
                          }
                          alt=""
                          className="d-signal-complete-details--image"
                        />
                        <img
                          src={RightArrow}
                          alt=""
                          className="d-signal-complete-details--image"
                          onClick={() => {
                            dispatch({
                              type: payloadTypes.SET_JUNCTION_ID,
                              payload: {
                                junctionID: data.id,
                              },
                            });
                            setJunctionDetails(!junctionDetails);
                          }}
                        />
                      </div>
                    </div>
                  </li>
                );
              })
            ) : (
              <b className="nodata">No data found</b>
            )}
          </ul>
        </div>
        <div className="row g-0">
          <div className="col">
            <Button mode="cancel" onClick={() => setModalFlag(false)} />
          </div>
          <div className="col flex-end">
            <Legends />
          </div>
        </div>
        <CustomModal
          isOpen={junctionDetails}
          onRequestClose={() => setJunctionDetails(!junctionDetails)}
          contentComponent={
            <JunctionWiseAsset setModalFlag={setJunctionDetails} />
          }
          style={AddModalStyles}
        />
        <CustomModal
          isOpen={ticketDetails}
          onRequestClose={() => setTicketDetails(!ticketDetails)}
          contentComponent={
            <>
              <RaisedTicketDetails
                setModalFlag={() => setTicketDetails(!ticketDetails)}
                pageFor={AssetDetailsPageFor.REPORTS}
                assetType={TableType.JUNCTION}
              />
            </>
          }
          style={AddModalStyles}
        />
        <CustomModal
          isOpen={mapView}
          onRequestClose={() => setMapView(!mapView)}
          contentComponent={
            <APIProvider apiKey={process.env.React_App_MAP!}>
              <AssetTypeMapView />
            </APIProvider>
          }
          style={AddModalStyles}
        />
        {/* <CustomDrawer
          anchor="right"
          open={junctionDetails}
          onClose={() => setJunctionDetails(!junctionDetails)}
        >
         
        </CustomDrawer> */}
        <LoadingModal flag={loading} />
      </div>
    </>
  );
};

export default CompleteSignalDetails;
